import { render, staticRenderFns } from "./TranslatedEditor.vue?vue&type=template&id=0747c888&scoped=true&"
import script from "./TranslatedEditor.vue?vue&type=script&lang=js&"
export * from "./TranslatedEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747c888",
  null
  
)

export default component.exports